import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SectionHeading from './SectionHeading';
import EntryCard from './EntryCard';
import TipsterLogo from './TipsterLogo';
import { useData } from '../context/DataContext';
import { summarize } from '../lib/tips';

export default function RecentResults() {
  const { tipsters, entriesFor } = useData();
  return (
    <section className="py-24 md:py-32 bg-mist border-y border-line" data-testid="recent-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="Latest results"
            title="Three archives. Updated every day."
            lead="The most recent releases from each tipster. Combined odds on Doubles are calculated automatically."
          />
          <Link to="/results" className="btn-primary flex-shrink-0" data-testid="recent-view-archive">Open the full archives <ArrowRight className="w-4 h-4" /></Link>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-6">
          {tipsters.map(t => {
            const list = entriesFor(t.id);
            const s = summarize(list);
            return (
              <div key={t.id} data-testid={`recent-column-${t.id}`}>
                <div className="flex items-center gap-3 mb-4">
                  <TipsterLogo tipster={t} className="w-10 h-10" />
                  <div className="flex-1">
                    <div className="font-display font-bold text-navy">{t.name}</div>
                    <div className="text-[11px] text-slate-500">{s.won}W – {s.lost}L · avg {s.avgOdds}</div>
                  </div>
                  <Link to={`/results?t=${t.id}`} className="text-xs font-semibold text-royal hover:underline">All →</Link>
                </div>
                <div className="grid gap-3">
                  {list.slice(0, 3).map(e => <EntryCard key={e.id} entry={e} compact />)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
